import Swal from "sweetalert2";

export const toast = props => {
  return Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: props.icon === "success" ? 3000 : 5000,
    timerProgressBar: true,
    didOpen: toast => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  }).fire(props);
};

export const swalAlert = (
  title,
  text,
  confirmText,
  cancelText,
  confirmButtonColor
) => {
  const props = {
    title,
    showCancelButton: true,
    confirmButtonColor: confirmButtonColor || "",
    confirmButtonText: confirmText || "Ok",
    cancelButtonText: cancelText || "Cancelar",
  };
  if (text) props.text = text;
  return Swal.fire(props);
};

export const swalWarningAlert = (text, confirmText) => {
  return Swal.fire({
    title: "Atención",
    text,
    confirmButtonText: confirmText || "Ok",
  });
};
